// extracted by mini-css-extract-plugin
export default {"list":"ancillary-sidebar-block_list__t5KW6","listItem":"ancillary-sidebar-block_listItem__CKbtw","footer":"ancillary-sidebar-block_footer__dct-j"};